import { Component, ViewChild, ViewChildren, QueryList, ElementRef, OnInit, ViewEncapsulation } from '@angular/core';
import { MainService } from './core/main.service';
import { AppConfig } from '../environments/environment';
import { BrowserModule, DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import {Title} from "@angular/platform-browser";
import {Subscription, interval, timer} from 'rxjs';
import { map } from 'rxjs/operators';
import { ElectronService } from 'ngx-electron';

import { Species, ImageInfos, Help } from "../classes/classes";
import { ReturnStatement } from '@angular/compiler';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {
  public debug:boolean = false;

  private datasServer:any;
  public datasName:any;
  public base:string;
  public datas:any;
  public datasdev:any;

  private activityDelay:number = 5*60*1000; //ms
  private activitySubscription:Subscription;

  public debugTxt:string;

  public current:string = 'loading';
  public step:number;
  public winner:string;

  public bgImage:any;
  public boardImage:any;

  public isVP:any;

  private videoFolders:any;
  public currentVideo:string;
  private videoSubscription:Subscription;
  public loop:boolean;

  public photosNb:number = 10000;
  public photo0;
  public photo1;
  public photo2;
  public matches:Array<any>;
  public match;
  public selectedCriterias:Array<any>;
  
  
  public mixer:Array<number>;
  public positions:Array<any>;

  public collection:Array<number> = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];

  private espaces:Array<any> = [
    {
      name: 'Végétale',
      color: '#fbab18'
    },
    {
      name: 'Animale',
      color: '#ee4991'
    },
    {
      name: 'Humaine',
      color: '#00aab0'
    },
    {
      name: 'Artificielle',
      color: '#ef4023'
    }
  ];

  public espace = this.espaces[3];

  @ViewChild('video', {static: false}) videoTag : ElementRef;
  videoProgress:number = 0;

  constructor(
    private service: MainService,
    public sanitizer:DomSanitizer,
    private titleService: Title,
    private electron: ElectronService
  ) { }

  ngOnInit():void
  {
    this.log('ngOnInit');

    if (window.hasOwnProperty('process') && window['process'].hasOwnProperty('versions') && window['process']['versions'].hasOwnProperty('electron')) { // electron
      let response: any = this.electron.ipcRenderer.sendSync('ping');
      this.datasName = response.datas;
      this.service.base = response.base;
      this.base = this.service.base;
    } else {
      this.datasName = this.findGetParameter('datas');
      this.base = AppConfig.datasServer;
    }
    this.log("this.datasName", this.datasName);

    this.checkIfVP();
    this.loadDatas();

    window.addEventListener('idal-contact-event', (e) => {
      let info = e['detail'];
      this.log("Input contact name: " + info.name);
      let port = info.values.findIndex(elt => elt);
      if (port == 0){

      }
    });
  }

  checkIfVP():void
  {
    // Detect Wave System player in VP330 ou VP320
    this.isVP = navigator.userAgent.search("WSPlayer") != -1;
  }

  loadDatas():void
  {
    this.current = 'loading';
    // this.service.loadDatasDev(this.datasName).subscribe((datas => {
    //   this.datasdev = datas;
      this.service.loadDatas(this.datasName).subscribe((datas => {

        // this.service.loadRandomCSV(this.datasName, this.photosNb, 0.3).subscribe((response) => {
        //   console.log(response.length);
        //   return response;
        // });

        this.datas = datas;
        // console.log(datas);

        this.titleService.setTitle( this.datas.name );
        this.service.loadVideoFolders(this.datasName).subscribe((datas) => {
          this.videoFolders = datas;
          this.start();
        });

      }));
    // }));
  }

  start():void
  {
    this.bgImage = this.sanitizer.bypassSecurityTrustStyle('url('+ this.base+this.datasName+'/files/'+this.datas.image +')');
    this.boardImage = this.sanitizer.bypassSecurityTrustStyle('url('+ this.base+this.datasName+'/files/'+this.datas.bg +')');
    this.goHome();
    // this.startGame();
  }

  clear():void
  {
    delete this.photo0;
    delete this.photo1;
    delete this.photo2;
    this.winner = '';
    this.matches = [];
    delete this.match;
    this.step = 0;
    this.selectedCriterias = [];
  }

  goHome():void
  {
    this.clear();
    this.current = 'splash';
  }
  onSplashClick():void
  {
    if (AppConfig.name == 'web'){
      if (!document.fullscreenElement){ document.documentElement.requestFullscreen(); }
    }

    this.showIntroduction();
  }

  onClick():void
  {
    if (this.activitySubscription){
      this.activitySubscription.unsubscribe();
      delete this.activitySubscription;
    }
    this.activitySubscription = timer(this.activityDelay).subscribe(() => {
      this.log("activitySubscription");
      window.location.href = window.location+"index.html";
      // this.goHome();
    });
  }

  startGame():void
  {
    this.current = 'game';
    this.clear();

    this.service.loadRandomCSV(this.datasName, this.photosNb, 0.3).subscribe((response) => {
      console.log(response.length+' pioches');
      let datas = response;
      // let datas = response.pop();
      let tab = datas.split(',').map(elt => 1*parseFloat(elt));
      let index = tab.indexOf(0);
      let fileName = this.formatNumber(index, 5);
      this.photo0 = {
        index: index,
        sanitized: this.sanitizer.bypassSecurityTrustStyle('url('+ this.base+this.datasName+'/filesDev/photos/'+fileName+'.jpg)')
      };
      // this.collection = this.collection.map((num) =>Math.floor((this.photosNb-2)/(this.collection.length-1)*num));

      let max = tab.reduce((acc, elt) => Math.max(acc, parseFloat(elt)*1), 0);
      let sorted = tab
        .splice(0, this.photosNb) // si d'aventure, il y avait trop de photos !?
        .map((elt, i) => { return {index:i, score: Math.round(parseFloat(elt)*100)/100, match: Math.round((1-parseFloat(elt))*100)}; })
        .sort((a, b) => Math.sign(b.score - a.score))
        .filter((elt) => elt.score != 0) // enlever l'image de référence
        .reverse();
        
      this.matches = this.collection.map((num) => sorted[num]);
      this.matches.forEach((elt, index) => elt.order = index);

      this.match = this.matches[0];
      fileName = this.formatNumber(this.match.index, 5);
      this.photo2 = {
        index: this.match.index,
        order: this.match.order,
        score: this.match.score,
        sanitized: this.sanitizer.bypassSecurityTrustStyle('url('+ this.base+this.datasName+'/filesDev/photos/'+fileName+'.jpg)')
      };  
      
      this.mixer = this.matches.map((elt, i) => i*1);
      this.mixer.sort(() => 0.5-Math.random());
  
      this.positions = this.matches.map((elt, i) => ({
        left: (i%5)*20+'%',
        top: (Math.floor(i/5))*20+'%'
      }));
      console.log(this.positions);
    });
    
    
    // let index = Math.floor(this.photosNb*Math.random());


    // this.service.loadTextFile(this.datasName+'/filesDev/s'+this.formatNumber(index, 4)+'.txt').subscribe((res) => {
    // });

    this.step++;
  }
  onOkSelectYours():void
  {
    this.step++;
  }
  onOkSelect(match):void
  {
    if (this.step == 1 || this.step == 2){
      let fileName = this.formatNumber(match.index, 5);
      this.photo1 = {
        index: match.index,
        order: match.order,
        score: match.score,
        sanitized: this.sanitizer.bypassSecurityTrustStyle('url('+ this.base+this.datasName+'/filesDev/photos/'+fileName+'.jpg)')
      };
      this.step = 2;
    }
  }
  onOkSelectConfirm(match):void
  {
    // this.step = 3;
  }
  onShowIA(){
    this.mixer.sort((a, b) => (1*a)-(1*b));
    this.step++;
  }
  onSavoir():void {
    this.step++;  
  }
  onSelectOk():void
  {
    this.step++;
  }
  onSelectKo():void
  {
    delete this.photo1;
  }
  onWin(winner:string):void
  {
    if (!this.winner){
      this.step++;
    }
    this.winner = winner;
  }
  onCriteria(criteria):void
  {
    let index = this.selectedCriterias.indexOf(criteria);
    if (index == -1){
      this.selectedCriterias.push(criteria);
    } else {
      this.selectedCriterias.splice(index, 1);
    }
  }
  isSelected(criteria):boolean
  {
    return this.selectedCriterias.indexOf(criteria) != -1;
  }

  sanitizeMatch(match)
  {
    let fileName = this.formatNumber(match.index, 5);
    return {
      index: match.index,
      sanitized: this.sanitizer.bypassSecurityTrustStyle('url('+ this.base+this.datasName+'/filesDev/photos/'+fileName+'.jpg)')
    };
  }


  // --------------------------
  showIntroduction():void
  {
    this.current = 'introduction';
  }
  onInstructionClick():void
  {
    this.startGame();
  }
  showConclusion():void
  {
    this.current = 'conclusion';
  }
  onRestart():void
  {
    this.goHome();
  }
  onOther():void
  {
    this.startGame();
  }
  // --------------------------


  /**********************************************************************/
  /* VIDEO *************************************************************/

  showVideo(num:number):void
  {
    this.current = 'video';
    this.playVideo({base: this.datas.scenario[num].video, inc: num}, false);
  }

  playVideo(folderBaseAndInc, loop){
    this.log('***********');
    this.current = 'video';
    let folder:string = folderBaseAndInc.base;

    let folderSplit = folder.split('*');
    if (folderSplit.length > 1){
      let num = parseInt(folderSplit.shift());
      if (folderBaseAndInc.inc != null){
        num += folderBaseAndInc.inc;
      }
      folder = this.toStringLen(num, 3) + folderSplit.join('');
    }

    if (this.isVP){
      this.playVideoExt(folder);
    } else {
      this.playVideoWeb(folder, loop);
    }
    this.log('current', this.current);
  }
  playVideoWeb(videoFolder:string, loop:boolean){
    this.loop = loop;

    let sel = this.videoFolders.filter((elt) => elt.folder == videoFolder);
    if (sel.length){
      this.currentVideo = videoFolder+'/'+sel[0].video;
      this.videoSubscription = interval(1000).subscribe(() => {
        this.videoUpdate();
      });
    }

  }
  playVideoExt(videoFolder:string){
    this.currentVideo = videoFolder;

    let folderSplit = videoFolder.split('/');
    let folderNum = parseInt(folderSplit.shift());
    // let toPlay = this.videoFolders.filter((videoFolder) => video == videoFolder.video);
    // let folder = parseInt(toPlay[0].folder);

    this.log(window['IDAL'].getControlInterfaces);
    window['IDAL'].getControlInterfaces().then((ifaces) => {
      this.log('got ifaces');
      this.log("load", folderNum);

      ifaces.player.stop().then(() => {
        ifaces.player.playFolder(folderNum).then((ret) => {
          this.log('playing');
        }).catch(function(error) {
          this.log("control interface error");
          // Faire quelque chose d'utile...
        });
      });
    });
  }

  getPoster(videoSrc){
    return videoSrc.replace('.mp4', '.jpg');
  }
  videoUpdate(){
    if (this.videoTag && this.videoTag.nativeElement){
      this.videoProgress = Math.round(100 * this.videoTag.nativeElement.currentTime / this.videoTag.nativeElement.duration);
    } else {
      this.videoProgress = 0;
    }
  }
  onVideoEnded(e){
    if (this.videoSubscription){
      this.videoSubscription.unsubscribe();
      delete this.videoSubscription;
    }
    this.videoProgress = 100;

  }
  onTimeupdate(e){
    // if (this.videoSubscription){
    //   this.videoSubscription.unsubscribe();
    //   delete this.videoSubscription;
    // }
    // this.videoProgress = 100;
    //
  }
  onVideoClick(){
    // this.current = 'splash';
  }


  /**********************************************************************/
  /* TOOLS **************************************************************/

  findGetParameter(parameterName:string):void
  {
      let result = null,
          tmp = [];
      let items = location.search.substr(1).split("&");
      for (let index = 0; index < items.length; index++) {
          tmp = items[index].split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      }
      return result;
  }

  toStringLen(num:number, len:number):string
  {
    let ret = ''+num;
    while(ret.length < len){
      ret = '0'+ret;
    }
    return ret;
  }

  rank(i):string
  {
    let suffix = '<sup>ème</sup>';
    if (i == 0){
      suffix = '<sup>ère</sup>';
    }
    i = i+1;
    return i+suffix;
  }

  log(...txts:any):void
  {
    if (true || this.isVP){
      this.debugTxt += txts.join(', ');
      this.debugTxt += '<br>';
    } else {
      this.log(...txts);
    }
  }

  formatNumber(value:number, length:number):string
  {
    let text = '00000000000000000000000000'+value;
    return text.substring(text.length-length, text.length);
  }

  formatPercent(value:number, decNumber:number):string
  {
    let val = Math.round(value*100*Math.pow(10, decNumber))/Math.pow(10, decNumber);
    return val+"%";
  }


}
